export function getMeasurementsCacheKey( obj: { shape: string; primitives: object; edgeFinish: string }, dxfExport = '' ): string {
	const primitivesIdentifier = Object.keys( obj.primitives ).map( ( dimension ) => {
		return `${dimension}-${obj.primitives[ dimension ]}`;
	} ).join( ',' );

	return `${obj.shape}:${primitivesIdentifier}:${dxfExport}:${obj.edgeFinish}`;
}
